'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  React.useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Courses', href: '#courses' },
    { label: 'SHS Learning', href: '/shs-dashboard' },
    { label: 'Instructors', href: '#instructors' },
    { label: 'For Schools', href: '#pricing' },
    { label: 'About', href: '#about' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md shadow-sm border-b border-border' : 'bg-transparent'}`}>
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 h-16 flex items-center gap-6">
        <Link href="/" className="flex items-center">
          <AppLogo
            src="/assets/images/88677115-9FA9-456F-83F8-0F9B0A4E39DD-1778605171623.png"
            size={250}
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-1 ml-6">
          {navLinks?.map((link) => (
            <Link
              key={`nav-${link?.label}`}
              href={link?.href}
              className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-all"
            >
              {link?.label}
            </Link>
          ))}
        </nav>

        <div className="ml-auto hidden lg:flex items-center gap-3">
          <Link
            href="/sign-up-login-screen"
            className="px-4 py-2 text-sm font-semibold text-primary hover:bg-secondary rounded-lg transition-all"
          >
            Sign In
          </Link>
          <Link
            href="/sign-up-login-screen"
            className="px-5 py-2 text-sm font-semibold text-white gradient-purple rounded-xl hover:opacity-90 transition-all shadow-purple"
          >
            Get Started Free
          </Link>
        </div>

        <button
          className="ml-auto lg:hidden p-2 rounded-lg hover:bg-muted transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <Icon name={mobileOpen ? 'XMarkIcon' : 'Bars3Icon'} size={22} className="text-foreground" />
        </button>
      </div>
      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-border px-6 py-4 space-y-2">
          {navLinks?.map((link) => (
            <Link
              key={`mobile-nav-${link?.label}`}
              href={link?.href}
              className="block px-3 py-2.5 text-sm font-medium text-foreground hover:bg-muted rounded-lg transition-all"
              onClick={() => setMobileOpen(false)}
            >
              {link?.label}
            </Link>
          ))}
          <div className="pt-2 border-t border-border flex flex-col gap-2">
            <Link href="/sign-up-login-screen" className="px-3 py-2.5 text-sm font-semibold text-primary text-center border border-primary rounded-xl">Sign In</Link>
            <Link href="/sign-up-login-screen" className="px-3 py-2.5 text-sm font-semibold text-white gradient-purple rounded-xl text-center">Get Started Free</Link>
          </div>
        </div>
      )}
    </header>
  );
}